// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HistoryOutlinedSvg from "@ant-design/icons-svg/es/asn/HistoryOutlined";
import AntdIcon from '../components/AntdIcon';

var HistoryOutlined = function HistoryOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: HistoryOutlinedSvg
  }));
};

HistoryOutlined.displayName = 'HistoryOutlined';
export default React.forwardRef(HistoryOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/HistoryOutlined.js
// module id = 1313
// module chunks = 0